
// console.clear();
var animationCreated = false;

var url_string = window.location.href;
var url = new URL(url_string);
var id = url.searchParams.get("tokenID");

var seeds = ["Tanish Rahuman","ICPBunny","CasaGrand Aqua","Waheed_Rahuman","bob","Bob","marspool","icptothemoon","OKA_Family","_we_are_all_brothers_on_the_planet","popo","DFINITY","lucky_strike","techno","DOMINIC","0123456789Tar!","Live_with_joy","Sun","telex883","dfinity","Dfinity","christmass","chebdenis","Navigator","In_leaves_no_step_had_trodden_black","АртемМаюновский","Hello_World","Kalina","Crying_Light","zszmh-swkyt-33dgu-swpwq-7hdrq-qx7oq-mm7ih-r5lmi-xw","Chrismast","Marspool","Moonlight","330i","zgmpt-l5w3w-afpvt-v7ymd-fkkwo-zunx7-jj5ms-l3bnr-tb","Metaverse","paul","Anastasia","dominic-williams","Internet_Computer","how_to_look_at_my_nft?","Bitcoin","Ethereum","barabulka","NFT","Anhchienmk","DfinityICP","Expecto_Patronum","lgou2-gi3of-erfww-fclyg-t57po-3jtbk-447ou-7guz7-jx","ac9eb89322f48f73411b429259e98f6c7c64811d4c4c052949","Defi","Christian_Jose","marooon","Infinity","yoshinori","China","3v6mj-febx4-gz6mn-fksqk-yw5uc-jzu7p-aa5bo-t6aiw-so","Confundo","motoko","Obliviate","Limbo","P2E","CjbtZ3AuRJdGxfcpP495m8nDBUzgq6","xa2sz-7c76r-qbdui-bf2xo-77i7d-hxx2a-qlgsp-zfe2q-lm","839651559","c_okenwa","jjhh","InternetComputer","bunny","Avada_Kedavra","Icp_is_the_best","Dominic_Williams","2czss-azgg2-xkp2v-boeod-22l6y-uiggh-4zhdg-6qbum-nl","Chienpa","tonyctv","elon","levis","BaBoBapBapBapBapBap","bitcoin","Dfinity_Foundation","NN_Channel","TomTitMit","23rat-l3lh3-m2jvl-hl63l-uzhji-d3vdl-fzy3s-iuxxz-gw","2022年BTC1億円","poked_bot","ETH","8yeargang","abc","WqSFgbpVeP6aQXsnjTKyEA5krux2CB","MarsPoolDOM","777","999","thanglun1234","America","SEED","ton2g","888","DfinityFoundation","fzwzd-pghmk-r4n5e-bnhxh-62yvu-mdz4s-tjgzj-yfayt-jt","web3.0","theearth","caobalanh","3154eb7d22672b3b8ae1c62f9492f2a5549c03670505bae0eb","MarsPoolInternetComputer","Seed","7777","abcdefghijklmnopqrstuvwxyz","Elon_Musk","ICPbunny","Powered_by_Internet_Computer","0.8","c_nook","eth","Kakalot","eltonjohn","Mars_Music_ICP","333","noname","ven7z-5bn4g-yp4qi-yssdb-gtnfu-wplq2-7kh6o-6fbnd-em","330j","Apple","Amir999","seed","453","tahainam1234","entrepot","phucadword","anrty-ontea-czg37-aezkc-3gmqm-jvytd-uhdaq-cwkp2-iu","DominicWilliams","btc","ITACH","Marspool_frank","tahainam123456","michaeljackson","816","vnaronlim","∞","tahainam1234567","Cadic","kien","DSCVR","Vitalik_Buterin","genesis","God","arosec","Naruto","phucleo","marspool_NFT","tahainam1234@","Seed-phrase","Địt_lồn_mẹ_mày","Mars01","ICPunks","linhvang","metaverse","Dom.nft","Satoshi_Nakamoto","MarsPool_","dance_music","Sasuke","Dom.icp","Galaxy","rock'n'roll","livahot","Ethereum>Bitcoin","ballad_music","Triump","Telegram","google","555","apple","circle","tesla","Pokedbots","furi","nft_nice","internet","facebook","Rings","Stus","HipHop","MarsPool_#_1","Gavin_Wood","metavese","River_flow_in_you","punk","nftbunny","H2E","ROSE","binance","Badboy","i_love_you","internetCompu","bnb","Motoko","I_Love_ICP","I_Hate_ICP","sol","blondegirl","aywmp-q4gf7-6iso4-27ih5-gvg6j-2t7xp-bsabz-hftnn-fr","Computer_Internet","Crazy_house","ICP_1_000_$","internetcomputer","blueocean","Greece_Athens_Alexandros_Megas","ICP_is_The_King","Neon","Mr.Dom","samurai","I_want_my_MTV","Crypto","Cronic_Critters","Tokennomics","BITCOIN","And_drunk_the_milk_of_paradise_whoa_paradise","Universe","Polkadot","Mr_VooDoo","whale","should","Web3","666","icp_to_the_moon","zzzzzzzzzzz_1","Leo","330k","zhi","227","229","kk2ge-kz42n-gtdpq-4fatv-yfl5s-qq6va-3tgti-qiwy2-32","330l","520","Internet-Computer","WhenBinance?!","330m","001","homer","330n","wtf","Blockchain","caicuccutgivay","∞∞∞","330o","person","330p","GOD","mars_and_saturn","330q","fire_ice_summer_winter","gaugaugau","Bitcoin_Price_is__43860_USD","nguyenkhanhhuongthao","jungle_way_way_margin_lobster","nguyenmaiphuong","stoicwallet","vietnamfinland","haimuoitrieu$","wbxnk-kikor-uwiaa-aaaaa-cuaab-eaqca-aaaaa-a","mlgucci","internetcomputer.org","maimaiyeuem","1111","SatoshiNakamotoBTCtotheMoon","Dfinity_are_the_new_Bitcoin_in_2024","https://xpollinate.io/","PokedStudio","PokedBots","Denver_Broncos_DoubleOhMike","027","I_Love_You","1000","haruxx","0.1","rkr3w-qdzff-lvev3-5f7y6-cjw7d-pkfgh-6visb-lritf-u5","🐇うさぎ","kang123456a","Bob_Marley_","Robert","Sierra","WAGMI","WGMI","iolfx-xcizn-x7275-e3wkc-o7dta-v5myu-2jgn2-bxaqc-jh","Traveling_Light","Monsters","zisu","1earth","Better_Than_A_Hallelujah","Marspool_music","panda","bitter_moon","One_day","Inspire","I'm_a_Dreamer","Five_Hundred_Miles","Stevennguyen01","my_heart_will_go_on","puzzle","quy","fghvfxdv","2wrlp-lnm5o-w2mux-gnmqj-45ovl-5i73g-n5xza-w44go-gv","sfsdfd","fdsfsf","0.2","tentech","bichnhi","swaaaaag","3aozf-symt7-kefw6-pjnwn-wh2lx-g7py6-mef6p-y47vm-zh","metataro","ctzt7-pfphi-jpejt-dlqiq-m76x4-dmxvh-u52xl-vtda2-7i","odacchi","Jay_Chou","stealth","udame-qm2wh-jr37l-rdwdg-wxd6i-yuq6m-hwztd-fnjvy-gz","sagattya","key","rainbow$colour@blue#red%green@violet!indigo9yellow","TutixNFT","vlnp6-egnqt-vxkqd-wzre2-l4f55-uudp2-6tvvq-f5tlv-gz","Jingle$bell4jingle4belljingle@all4the92waylove$","a4rk6-zva5t-rnbji-vn57v-slntc-ktroo-63wm4-i5ton-uu","vpyma-xrnkb-wvlhn-zsuqn-mao77-hasxd-fytxd-72je6-h2","do23b-a4qbj-pqlr7-hzs2k-jed2b-6z2db-ueab7-4mgkd-63","bui_hoang_linh","la_la_la_la_la_la_la","jazz","pepsi","zenlink","solana","ape","like","BNB","h7rlo-nd6ob-bxuvb-n3d3o-4rnws-bsakj-n5dk5-ia6wi-mm","people","game","KSM","random","sand","usdt","mint","china","Rise_up_this_mornin'_Smiled_with_the_risin'_sun","ICPswap","444","musk","400","yaan","one_two_three_four_five_six_seven_eight_nine_ten","Marspool-icp","oppo-life","New-ICP","Marspool-Life","Cool-Life","Bunnies_to_the_moon","nft-Music","Cool-Boy","Cool-body","POPA-life","minataro99","m7yfa-rmkhi-hkvvv-uvped-lunzp-feelo-7oh6a-dgck6-bb","Jackson-MUSIC","DM-ICP-NFT_MUSIC","mojito","hidan","MAŤO","weed","amidamaru","hockey","1999","icpnft","Peace_and_Love","Phongnguyen","Kimthanh","Hungnguyen","shogaku","Puppies","sex","Thuong","donchan","25yda-njc3z-kec75-tvamo-fwpg3-a5vf4-bdcba-v5q7a-mo","HWRD","marooon1","pirosiki","quplq","yasai-furikake","Hungthanhphong","phongbusinessman","ek","twitter","Twitter","Hideto","sloth","internet_computer","bluesyMango_X_pinkGrape","XXX","Happy_Birthday_to_you_!","disney","wagmi","Dominic_w","Cat_Pirate","Gas_free_Transactions","vhyv","405","Alain_Muse","CryptoJourney","EL_PASO","tanaka","Plug_Wallet","ssskkk009","Honey","YuliaZSPb","robot","driver","umanuma","963","horse","opennft","elonmask","ElonMusk","Snoop_Dogg","zoom_out_trust_the_process_","Coimbatore","Bored_Ape_Yacht_Club_","LOVELY_ONE","LoveICP","d18c72f7b77bd8f511ac3257304a9dd004110b10f7c085b1c0","735a6745232a52e8591712f6f645e57344f2f30b876cd37f18","A_Better_Future","DFINITYDECK_","Internet_Computer_ICP","your_foolish_heart","InTerneTCompuTer","bui_ngoc_minh_thu","nam_quoc_son_ha_nam_de_cu","Dom's_Magical_Pizza_Machine","Peaky_Blinders","Free","yusukeshono","dylan","cailro","snt7j-ghkja-62wpp-va5k2-xvfvr-xy6vq-l6wdg-a5cn6-z2","Token-230","hello_word","faktotum"];
var metadata = ['{"color":50, "bgcolor":2, "sides":8,"centercolor":4, "dots":9}','{"color":118, "bgcolor":1, "sides":10,"centercolor":1, "dots":13}','{"color":63, "bgcolor":2, "sides":5,"centercolor":5, "dots":16}','{"color":111, "bgcolor":7, "sides":15,"centercolor":3, "dots":23}','{"color":98, "bgcolor":3, "sides":11,"centercolor":5, "dots":5}','{"color":88, "bgcolor":7, "sides":10,"centercolor":5, "dots":16}','{"color":68, "bgcolor":5, "sides":23,"centercolor":1, "dots":10}','{"color":88, "bgcolor":6, "sides":5,"centercolor":1, "dots":14}','{"color":13, "bgcolor":8, "sides":2,"centercolor":4, "dots":23}','{"color":127, "bgcolor":2, "sides":13,"centercolor":5, "dots":7}','{"color":125, "bgcolor":4, "sides":7,"centercolor":4, "dots":23}','{"color":77, "bgcolor":8, "sides":11,"centercolor":3, "dots":24}','{"color":121, "bgcolor":1, "sides":8,"centercolor":2, "dots":23}','{"color":126, "bgcolor":9, "sides":6,"centercolor":5, "dots":8}','{"color":24, "bgcolor":8, "sides":2,"centercolor":4, "dots":8}','{"color":22, "bgcolor":9, "sides":10,"centercolor":2, "dots":13}','{"color":70, "bgcolor":7, "sides":16,"centercolor":1, "dots":21}','{"color":100, "bgcolor":1, "sides":11,"centercolor":5, "dots":23}','{"color":66, "bgcolor":2, "sides":7,"centercolor":1, "dots":9}','{"color":84, "bgcolor":5, "sides":32,"centercolor":1, "dots":10}','{"color":111, "bgcolor":4, "sides":12,"centercolor":4, "dots":7}','{"color":109, "bgcolor":4, "sides":14,"centercolor":1, "dots":14}','{"color":13, "bgcolor":2, "sides":13,"centercolor":2, "dots":14}','{"color":29, "bgcolor":3, "sides":10,"centercolor":5, "dots":10}','{"color":117, "bgcolor":3, "sides":7,"centercolor":5, "dots":18}','{"color":11, "bgcolor":6, "sides":15,"centercolor":5, "dots":22}','{"color":45, "bgcolor":9, "sides":5,"centercolor":1, "dots":7}','{"color":36, "bgcolor":5, "sides":13,"centercolor":1, "dots":10}','{"color":48, "bgcolor":5, "sides":3,"centercolor":5, "dots":6}','{"color":21, "bgcolor":2, "sides":15,"centercolor":4, "dots":7}','{"color":64, "bgcolor":9, "sides":2,"centercolor":3, "dots":13}','{"color":85, "bgcolor":6, "sides":2,"centercolor":2, "dots":11}','{"color":91, "bgcolor":6, "sides":7,"centercolor":1, "dots":20}','{"color":108, "bgcolor":2, "sides":6,"centercolor":4, "dots":13}','{"color":43, "bgcolor":7, "sides":13,"centercolor":5, "dots":19}','{"color":36, "bgcolor":3, "sides":3,"centercolor":3, "dots":24}','{"color":47, "bgcolor":6, "sides":13,"centercolor":1, "dots":17}','{"color":31, "bgcolor":2, "sides":14,"centercolor":4, "dots":13}','{"color":127, "bgcolor":5, "sides":4,"centercolor":4, "dots":9}','{"color":40, "bgcolor":2, "sides":8,"centercolor":5, "dots":4}','{"color":56, "bgcolor":7, "sides":9,"centercolor":5, "dots":8}','{"color":55, "bgcolor":2, "sides":13,"centercolor":4, "dots":15}','{"color":39, "bgcolor":5, "sides":3,"centercolor":2, "dots":15}','{"color":78, "bgcolor":5, "sides":10,"centercolor":5, "dots":15}','{"color":123, "bgcolor":2, "sides":9,"centercolor":3, "dots":25}','{"color":95, "bgcolor":5, "sides":14,"centercolor":1, "dots":10}','{"color":119, "bgcolor":6, "sides":6,"centercolor":4, "dots":11}','{"color":32, "bgcolor":1, "sides":12,"centercolor":3, "dots":7}','{"color":55, "bgcolor":1, "sides":9,"centercolor":3, "dots":12}','{"color":63, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":65, "bgcolor":6, "sides":6,"centercolor":3, "dots":9}','{"color":106, "bgcolor":1, "sides":12,"centercolor":5, "dots":9}','{"color":19, "bgcolor":5, "sides":12,"centercolor":4, "dots":9}','{"color":24, "bgcolor":2, "sides":12,"centercolor":2, "dots":17}','{"color":32, "bgcolor":5, "sides":3,"centercolor":1, "dots":10}','{"color":92, "bgcolor":6, "sides":12,"centercolor":4, "dots":16}','{"color":76, "bgcolor":5, "sides":6,"centercolor":1, "dots":10}','{"color":126, "bgcolor":7, "sides":12,"centercolor":2, "dots":25}','{"color":39, "bgcolor":1, "sides":8,"centercolor":2, "dots":17}','{"color":121, "bgcolor":4, "sides":4,"centercolor":3, "dots":12}','{"color":36, "bgcolor":9, "sides":11,"centercolor":5, "dots":3}','{"color":26, "bgcolor":2, "sides":2,"centercolor":3, "dots":24}','{"color":48, "bgcolor":4, "sides":12,"centercolor":2, "dots":10}','{"color":93, "bgcolor":5, "sides":7,"centercolor":1, "dots":10}','{"color":23, "bgcolor":5, "sides":8,"centercolor":1, "dots":10}','{"color":61, "bgcolor":3, "sides":3,"centercolor":4, "dots":3}','{"color":35, "bgcolor":5, "sides":6,"centercolor":1, "dots":10}','{"color":44, "bgcolor":8, "sides":9,"centercolor":1, "dots":6}','{"color":77, "bgcolor":5, "sides":18,"centercolor":1, "dots":10}','{"color":51, "bgcolor":3, "sides":5,"centercolor":1, "dots":13}','{"color":15, "bgcolor":3, "sides":6,"centercolor":3, "dots":10}','{"color":89, "bgcolor":5, "sides":14,"centercolor":3, "dots":15}','{"color":118, "bgcolor":1, "sides":14,"centercolor":5, "dots":11}','{"color":45, "bgcolor":5, "sides":13,"centercolor":1, "dots":10}','{"color":75, "bgcolor":5, "sides":15,"centercolor":1, "dots":10}','{"color":21, "bgcolor":2, "sides":7,"centercolor":3, "dots":14}','{"color":33, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":128, "bgcolor":8, "sides":12,"centercolor":4, "dots":17}','{"color":106, "bgcolor":8, "sides":8,"centercolor":1, "dots":17}','{"color":54, "bgcolor":5, "sides":14,"centercolor":1, "dots":10}','{"color":63, "bgcolor":5, "sides":4,"centercolor":1, "dots":10}','{"color":69, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":25, "bgcolor":5, "sides":22,"centercolor":1, "dots":10}','{"color":74, "bgcolor":4, "sides":4,"centercolor":3, "dots":9}','{"color":115, "bgcolor":4, "sides":11,"centercolor":2, "dots":16}','{"color":65, "bgcolor":6, "sides":10,"centercolor":2, "dots":21}','{"color":109, "bgcolor":7, "sides":5,"centercolor":4, "dots":19}','{"color":74, "bgcolor":1, "sides":12,"centercolor":3, "dots":15}','{"color":54, "bgcolor":7, "sides":6,"centercolor":5, "dots":23}','{"color":42, "bgcolor":4, "sides":11,"centercolor":3, "dots":12}','{"color":62, "bgcolor":5, "sides":4,"centercolor":5, "dots":9}','{"color":49, "bgcolor":7, "sides":7,"centercolor":5, "dots":14}','{"color":116, "bgcolor":6, "sides":10,"centercolor":5, "dots":11}','{"color":62, "bgcolor":7, "sides":11,"centercolor":3, "dots":16}','{"color":45, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":35, "bgcolor":6, "sides":15,"centercolor":4, "dots":3}','{"color":106, "bgcolor":8, "sides":15,"centercolor":2, "dots":12}','{"color":123, "bgcolor":2, "sides":14,"centercolor":4, "dots":11}','{"color":24, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":15, "bgcolor":7, "sides":11,"centercolor":4, "dots":1}','{"color":60, "bgcolor":2, "sides":9,"centercolor":4, "dots":24}','{"color":103, "bgcolor":9, "sides":14,"centercolor":5, "dots":11}','{"color":86, "bgcolor":8, "sides":15,"centercolor":2, "dots":9}','{"color":15, "bgcolor":3, "sides":2,"centercolor":4, "dots":9}','{"color":74, "bgcolor":7, "sides":7,"centercolor":3, "dots":8}','{"color":36, "bgcolor":8, "sides":5,"centercolor":2, "dots":21}','{"color":127, "bgcolor":7, "sides":6,"centercolor":5, "dots":9}','{"color":45, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}' ,'{"color":104, "bgcolor":4, "sides":6,"centercolor":5, "dots":18}','{"color":110, "bgcolor":9, "sides":12,"centercolor":2, "dots":25}','{"color":46, "bgcolor":6, "sides":11,"centercolor":5, "dots":18}','{"color":102, "bgcolor":4, "sides":13,"centercolor":2, "dots":21}','{"color":38, "bgcolor":6, "sides":12,"centercolor":5, "dots":19}','{"color":84, "bgcolor":8, "sides":3,"centercolor":5, "dots":24}','{"color":57, "bgcolor":1, "sides":4,"centercolor":4, "dots":19}','{"color":66, "bgcolor":9, "sides":4,"centercolor":4, "dots":18}','{"color":125, "bgcolor":7, "sides":5,"centercolor":3, "dots":1}','{"color":53, "bgcolor":5, "sides":11,"centercolor":1, "dots":10}','{"color":105, "bgcolor":3, "sides":6,"centercolor":4, "dots":21}','{"color":110, "bgcolor":9, "sides":15,"centercolor":3, "dots":1}','{"color":86, "bgcolor":2, "sides":7,"centercolor":3, "dots":18}','{"color":78, "bgcolor":9, "sides":10,"centercolor":1, "dots":17}','{"color":32, "bgcolor":5, "sides":5,"centercolor":1, "dots":10}','{"color":111, "bgcolor":5, "sides":12,"centercolor":3, "dots":23}','{"color":128, "bgcolor":3, "sides":7,"centercolor":4, "dots":2}','{"color":28, "bgcolor":7, "sides":4,"centercolor":4, "dots":17}','{"color":81, "bgcolor":1, "sides":15,"centercolor":1, "dots":3}','{"color":27, "bgcolor":1, "sides":7,"centercolor":5, "dots":4}','{"color":129, "bgcolor":6, "sides":14,"centercolor":4, "dots":12}','{"color":32, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":12, "bgcolor":6, "sides":2,"centercolor":3, "dots":10}','{"color":41, "bgcolor":1, "sides":7,"centercolor":4, "dots":1}','{"color":96, "bgcolor":4, "sides":16,"centercolor":4, "dots":15}','{"color":104, "bgcolor":4, "sides":14,"centercolor":2, "dots":3}','{"color":75, "bgcolor":2, "sides":16,"centercolor":1, "dots":13}','{"color":16, "bgcolor":5, "sides":3,"centercolor":2, "dots":18}','{"color":107, "bgcolor":9, "sides":4,"centercolor":3, "dots":18}','{"color":50, "bgcolor":3, "sides":8,"centercolor":2, "dots":11}','{"color":22, "bgcolor":1, "sides":12,"centercolor":2, "dots":11}','{"color":62, "bgcolor":1, "sides":3,"centercolor":5, "dots":13}','{"color":71, "bgcolor":7, "sides":7,"centercolor":2, "dots":1}','{"color":53, "bgcolor":9, "sides":5,"centercolor":3, "dots":24}','{"color":16, "bgcolor":2, "sides":7,"centercolor":4, "dots":25}','{"color":21, "bgcolor":3, "sides":11,"centercolor":2, "dots":15}','{"color":30, "bgcolor":7, "sides":9,"centercolor":2, "dots":8}','{"color":45, "bgcolor":5, "sides":8,"centercolor":3, "dots":18}','{"color":34, "bgcolor":5, "sides":4,"centercolor":4, "dots":11}','{"color":27, "bgcolor":5, "sides":3,"centercolor":3, "dots":10}','{"color":21, "bgcolor":8, "sides":10,"centercolor":1, "dots":5}','{"color":108, "bgcolor":5, "sides":10,"centercolor":1, "dots":13}','{"color":13, "bgcolor":5, "sides":10,"centercolor":1, "dots":10}','{"color":89, "bgcolor":5, "sides":3,"centercolor":1, "dots":15}','{"color":76, "bgcolor":1, "sides":2,"centercolor":2, "dots":7}','{"color":63, "bgcolor":8, "sides":3,"centercolor":1, "dots":18}','{"color":23, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":105, "bgcolor":9, "sides":12,"centercolor":5, "dots":12}','{"color":111, "bgcolor":4, "sides":15,"centercolor":4, "dots":25}','{"color":93, "bgcolor":5, "sides":12,"centercolor":5, "dots":21}','{"color":98, "bgcolor":3, "sides":11,"centercolor":3, "dots":9}','{"color":34, "bgcolor":5, "sides":9,"centercolor":1, "dots":10}','{"color":98, "bgcolor":5, "sides":13,"centercolor":2, "dots":14}','{"color":68, "bgcolor":9, "sides":11,"centercolor":4, "dots":15}','{"color":61, "bgcolor":5, "sides":10,"centercolor":2, "dots":6}','{"color":39, "bgcolor":4, "sides":13,"centercolor":5, "dots":17}','{"color":11, "bgcolor":2, "sides":9,"centercolor":4, "dots":16}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":57, "bgcolor":1, "sides":4,"centercolor":1, "dots":1}','{"color":32, "bgcolor":3, "sides":16,"centercolor":1, "dots":12}','{"color":13, "bgcolor":3, "sides":13,"centercolor":4, "dots":4}','{"color":111, "bgcolor":7, "sides":12,"centercolor":2, "dots":19}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":81, "bgcolor":8, "sides":16,"centercolor":5, "dots":21}','{"color":51, "bgcolor":1, "sides":10,"centercolor":2, "dots":14}','{"color":52, "bgcolor":6, "sides":16,"centercolor":2, "dots":21}','{"color":107, "bgcolor":2, "sides":2,"centercolor":5, "dots":17}','{"color":113, "bgcolor":6, "sides":15,"centercolor":5, "dots":9}','{"color":128, "bgcolor":1, "sides":12,"centercolor":1, "dots":13}','{"color":14, "bgcolor":5, "sides":2,"centercolor":4, "dots":8}','{"color":35, "bgcolor":9, "sides":6,"centercolor":5, "dots":11}','{"color":105, "bgcolor":8, "sides":3,"centercolor":4, "dots":23}','{"color":27, "bgcolor":4, "sides":14,"centercolor":5, "dots":15}','{"color":80, "bgcolor":1, "sides":14,"centercolor":1, "dots":25}','{"color":116, "bgcolor":6, "sides":13,"centercolor":1, "dots":13}','{"color":51, "bgcolor":2, "sides":3,"centercolor":2, "dots":2}','{"color":127, "bgcolor":9, "sides":13,"centercolor":3, "dots":10}','{"color":91, "bgcolor":8, "sides":16,"centercolor":1, "dots":21}','{"color":53, "bgcolor":6, "sides":11,"centercolor":3, "dots":20}','{"color":26, "bgcolor":7, "sides":14,"centercolor":5, "dots":5}','{"color":58, "bgcolor":3, "sides":7,"centercolor":4, "dots":23}','{"color":108, "bgcolor":2, "sides":16,"centercolor":4, "dots":25}','{"color":104, "bgcolor":9, "sides":16,"centercolor":3, "dots":24}','{"color":107, "bgcolor":3, "sides":5,"centercolor":4, "dots":8}','{"color":26, "bgcolor":5, "sides":4,"centercolor":2, "dots":6}','{"color":122, "bgcolor":8, "sides":5,"centercolor":5, "dots":3}','{"color":18, "bgcolor":6, "sides":7,"centercolor":5, "dots":17}','{"color":90, "bgcolor":5, "sides":10,"centercolor":3, "dots":9}','{"color":69, "bgcolor":9, "sides":15,"centercolor":5, "dots":24}','{"color":94, "bgcolor":7, "sides":9,"centercolor":5, "dots":14}','{"color":59, "bgcolor":9, "sides":11,"centercolor":5, "dots":22}','{"color":19, "bgcolor":3, "sides":4,"centercolor":1, "dots":3}','{"color":98, "bgcolor":1, "sides":16,"centercolor":3, "dots":21}','{"color":113, "bgcolor":2, "sides":9,"centercolor":1, "dots":7}','{"color":89, "bgcolor":9, "sides":13,"centercolor":5, "dots":9}','{"color":127, "bgcolor":7, "sides":10,"centercolor":2, "dots":8}','{"color":115, "bgcolor":2, "sides":14,"centercolor":3, "dots":13}','{"color":27, "bgcolor":1, "sides":3,"centercolor":5, "dots":14}','{"color":84, "bgcolor":4, "sides":13,"centercolor":3, "dots":14}','{"color":47, "bgcolor":6, "sides":10,"centercolor":3, "dots":10}','{"color":56, "bgcolor":6, "sides":12,"centercolor":2, "dots":6}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":14, "bgcolor":5, "sides":7,"centercolor":3, "dots":11}','{"color":65, "bgcolor":7, "sides":3,"centercolor":3, "dots":6}','{"color":37, "bgcolor":6, "sides":16,"centercolor":4, "dots":18}','{"color":100, "bgcolor":1, "sides":5,"centercolor":3, "dots":12}','{"color":103, "bgcolor":1, "sides":13,"centercolor":2, "dots":17}','{"color":44, "bgcolor":3, "sides":9,"centercolor":4, "dots":24}','{"color":101, "bgcolor":9, "sides":12,"centercolor":4, "dots":6}','{"color":97, "bgcolor":8, "sides":14,"centercolor":3, "dots":9}','{"color":20, "bgcolor":4, "sides":4,"centercolor":4, "dots":3}','{"color":38, "bgcolor":6, "sides":8,"centercolor":5, "dots":23}','{"color":39, "bgcolor":6, "sides":15,"centercolor":3, "dots":14}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":58, "bgcolor":3, "sides":6,"centercolor":3, "dots":17}','{"color":129, "bgcolor":1, "sides":13,"centercolor":2, "dots":25}','{"color":125, "bgcolor":1, "sides":14,"centercolor":1, "dots":6}','{"color":38, "bgcolor":5, "sides":7,"centercolor":1, "dots":24}','{"color":79, "bgcolor":3, "sides":5,"centercolor":4, "dots":14}','{"color":63, "bgcolor":8, "sides":16,"centercolor":2, "dots":10}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":83, "bgcolor":4, "sides":15,"centercolor":2, "dots":13}','{"color":125, "bgcolor":7, "sides":3,"centercolor":5, "dots":25}','{"color":52, "bgcolor":4, "sides":7,"centercolor":1, "dots":16}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":11, "bgcolor":1, "sides":12,"centercolor":2, "dots":7}','{"color":64, "bgcolor":1, "sides":5,"centercolor":1, "dots":25}','{"color":97, "bgcolor":8, "sides":5,"centercolor":5, "dots":11}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":84, "bgcolor":7, "sides":14,"centercolor":1, "dots":9}','{"color":94, "bgcolor":4, "sides":16,"centercolor":4, "dots":7}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":94, "bgcolor":1, "sides":14,"centercolor":1, "dots":17}','{"color":126, "bgcolor":6, "sides":5,"centercolor":4, "dots":5}','{"color":124, "bgcolor":5, "sides":5,"centercolor":3, "dots":10}','{"color":86, "bgcolor":7, "sides":5,"centercolor":5, "dots":4}','{"color":15, "bgcolor":5, "sides":8,"centercolor":1, "dots":6}','{"color":26, "bgcolor":7, "sides":15,"centercolor":2, "dots":24}','{"color":114, "bgcolor":8, "sides":16,"centercolor":5, "dots":17}','{"color":64, "bgcolor":5, "sides":11,"centercolor":4, "dots":21}','{"color":42, "bgcolor":9, "sides":10,"centercolor":4, "dots":6}','{"color":87, "bgcolor":2, "sides":13,"centercolor":3, "dots":10}','{"color":59, "bgcolor":9, "sides":10,"centercolor":2, "dots":22}','{"color":38, "bgcolor":4, "sides":16,"centercolor":3, "dots":4}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":42, "bgcolor":5, "sides":7,"centercolor":3, "dots":14}','{"color":106, "bgcolor":4, "sides":3,"centercolor":4, "dots":20}','{"color":71, "bgcolor":1, "sides":4,"centercolor":5, "dots":24}','{"color":109, "bgcolor":6, "sides":2,"centercolor":2, "dots":20}','{"color":104, "bgcolor":3, "sides":15,"centercolor":3, "dots":5}','{"color":57, "bgcolor":3, "sides":3,"centercolor":5, "dots":21}','{"color":114, "bgcolor":5, "sides":8,"centercolor":3, "dots":12}','{"color":22, "bgcolor":3, "sides":7,"centercolor":4, "dots":17}','{"color":68, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":40, "bgcolor":9, "sides":7,"centercolor":3, "dots":10}','{"color":19, "bgcolor":7, "sides":2,"centercolor":3, "dots":14}','{"color":58, "bgcolor":7, "sides":16,"centercolor":1, "dots":16}','{"color":113, "bgcolor":2, "sides":2,"centercolor":4, "dots":17}','{"color":34, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":11, "bgcolor":9, "sides":7,"centercolor":5, "dots":13}','{"color":18, "bgcolor":5, "sides":11,"centercolor":1, "dots":5}','{"color":98, "bgcolor":8, "sides":14,"centercolor":3, "dots":24}','{"color":62, "bgcolor":4, "sides":15,"centercolor":4, "dots":1}','{"color":53, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":63, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":59, "bgcolor":2, "sides":3,"centercolor":2, "dots":18}','{"color":17, "bgcolor":5, "sides":13,"centercolor":1, "dots":16}','{"color":24, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":98, "bgcolor":3, "sides":11,"centercolor":4, "dots":10}','{"color":66, "bgcolor":9, "sides":7,"centercolor":3, "dots":9}','{"color":11, "bgcolor":6, "sides":7,"centercolor":2, "dots":4}','{"color":84, "bgcolor":2, "sides":12,"centercolor":1, "dots":20}','{"color":64, "bgcolor":9, "sides":5,"centercolor":1, "dots":25}','{"color":27, "bgcolor":7, "sides":3,"centercolor":5, "dots":18}','{"color":44, "bgcolor":3, "sides":3,"centercolor":3, "dots":20}','{"color":50, "bgcolor":4, "sides":13,"centercolor":2, "dots":9}','{"color":13, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":16, "bgcolor":6, "sides":2,"centercolor":3, "dots":6}','{"color":80, "bgcolor":1, "sides":9,"centercolor":5, "dots":8}','{"color":82, "bgcolor":2, "sides":3,"centercolor":5, "dots":13}','{"color":53, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":15, "bgcolor":1, "sides":11,"centercolor":5, "dots":18}','{"color":102, "bgcolor":5, "sides":9,"centercolor":3, "dots":6}','{"color":116, "bgcolor":1, "sides":10,"centercolor":4, "dots":14}','{"color":85, "bgcolor":4, "sides":9,"centercolor":2, "dots":16}','{"color":57, "bgcolor":7, "sides":12,"centercolor":5, "dots":11}','{"color":54, "bgcolor":2, "sides":2,"centercolor":1, "dots":12}','{"color":71, "bgcolor":1, "sides":3,"centercolor":1, "dots":14}','{"color":63, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":32, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":90, "bgcolor":2, "sides":2,"centercolor":2, "dots":24}','{"color":52, "bgcolor":8, "sides":4,"centercolor":2, "dots":8}','{"color":63, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":118, "bgcolor":2, "sides":16,"centercolor":2, "dots":24}','{"color":104, "bgcolor":9, "sides":3,"centercolor":1, "dots":25}','{"color":72, "bgcolor":5, "sides":11,"centercolor":4, "dots":18}','{"color":11, "bgcolor":9, "sides":6,"centercolor":3, "dots":10}','{"color":64, "bgcolor":9, "sides":4,"centercolor":3, "dots":8}','{"color":67, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":76, "bgcolor":6, "sides":16,"centercolor":4, "dots":19}','{"color":45, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":90, "bgcolor":5, "sides":9,"centercolor":5, "dots":17}','{"color":67, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":96, "bgcolor":7, "sides":12,"centercolor":2, "dots":9}','{"color":42, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":55, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":116, "bgcolor":7, "sides":13,"centercolor":1, "dots":17}','{"color":112, "bgcolor":8, "sides":4,"centercolor":1, "dots":24}','{"color":28, "bgcolor":5, "sides":11,"centercolor":5, "dots":24}','{"color":61, "bgcolor":5, "sides":9,"centercolor":1, "dots":17}','{"color":123, "bgcolor":7, "sides":14,"centercolor":5, "dots":18}','{"color":30, "bgcolor":2, "sides":15,"centercolor":2, "dots":18}','{"color":77, "bgcolor":5, "sides":12,"centercolor":2, "dots":16}','{"color":110, "bgcolor":7, "sides":14,"centercolor":1, "dots":8}','{"color":121, "bgcolor":2, "sides":3,"centercolor":5, "dots":8}','{"color":68, "bgcolor":6, "sides":2,"centercolor":5, "dots":19}','{"color":34, "bgcolor":4, "sides":12,"centercolor":5, "dots":22}','{"color":56, "bgcolor":2, "sides":16,"centercolor":1, "dots":6}','{"color":102, "bgcolor":9, "sides":2,"centercolor":3, "dots":20}','{"color":26, "bgcolor":7, "sides":5,"centercolor":2, "dots":12}','{"color":59, "bgcolor":2, "sides":11,"centercolor":4, "dots":14}','{"color":60, "bgcolor":7, "sides":7,"centercolor":4, "dots":16}','{"color":51, "bgcolor":4, "sides":11,"centercolor":2, "dots":18}','{"color":45, "bgcolor":1, "sides":7,"centercolor":3, "dots":10}','{"color":110, "bgcolor":3, "sides":13,"centercolor":3, "dots":4}','{"color":48, "bgcolor":5, "sides":13,"centercolor":5, "dots":15}','{"color":127, "bgcolor":1, "sides":13,"centercolor":4, "dots":15}','{"color":110, "bgcolor":9, "sides":14,"centercolor":2, "dots":5}','{"color":88, "bgcolor":6, "sides":5,"centercolor":2, "dots":21}','{"color":91, "bgcolor":8, "sides":14,"centercolor":1, "dots":8}','{"color":31, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":98, "bgcolor":8, "sides":10,"centercolor":5, "dots":24}','{"color":74, "bgcolor":9, "sides":7,"centercolor":1, "dots":17}','{"color":31, "bgcolor":5, "sides":11,"centercolor":3, "dots":4}','{"color":26, "bgcolor":5, "sides":12,"centercolor":5, "dots":19}','{"color":43, "bgcolor":5, "sides":16,"centercolor":5, "dots":7}','{"color":66, "bgcolor":8, "sides":3,"centercolor":1, "dots":6}','{"color":119, "bgcolor":6, "sides":8,"centercolor":3, "dots":23}','{"color":38, "bgcolor":9, "sides":12,"centercolor":4, "dots":15}','{"color":26, "bgcolor":4, "sides":7,"centercolor":5, "dots":24}','{"color":127, "bgcolor":2, "sides":11,"centercolor":3, "dots":9}','{"color":11, "bgcolor":2, "sides":10,"centercolor":3, "dots":17}','{"color":116, "bgcolor":1, "sides":2,"centercolor":1, "dots":13}','{"color":11, "bgcolor":9, "sides":16,"centercolor":5, "dots":23}','{"color":72, "bgcolor":6, "sides":11,"centercolor":4, "dots":20}','{"color":11, "bgcolor":5, "sides":6,"centercolor":2, "dots":10}','{"color":100, "bgcolor":7, "sides":2,"centercolor":2, "dots":14}','{"color":39, "bgcolor":8, "sides":11,"centercolor":5, "dots":20}','{"color":51, "bgcolor":7, "sides":12,"centercolor":4, "dots":12}','{"color":72, "bgcolor":7, "sides":6,"centercolor":3, "dots":11}','{"color":74, "bgcolor":7, "sides":7,"centercolor":5, "dots":15}','{"color":41, "bgcolor":6, "sides":7,"centercolor":1, "dots":25}','{"color":28, "bgcolor":1, "sides":10,"centercolor":4, "dots":14}','{"color":74, "bgcolor":5, "sides":5,"centercolor":1, "dots":10}','{"color":63, "bgcolor":6, "sides":5,"centercolor":3, "dots":17}','{"color":77, "bgcolor":7, "sides":5,"centercolor":5, "dots":7}','{"color":82, "bgcolor":1, "sides":14,"centercolor":3, "dots":10}','{"color":102, "bgcolor":2, "sides":8,"centercolor":3, "dots":20}','{"color":28, "bgcolor":7, "sides":3,"centercolor":1, "dots":18}','{"color":42, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":35, "bgcolor":6, "sides":8,"centercolor":4, "dots":2}','{"color":34, "bgcolor":8, "sides":9,"centercolor":1, "dots":18}','{"color":124, "bgcolor":6, "sides":15,"centercolor":3, "dots":25}','{"color":47, "bgcolor":6, "sides":8,"centercolor":5, "dots":11}','{"color":114, "bgcolor":8, "sides":6,"centercolor":5, "dots":2}','{"color":53, "bgcolor":8, "sides":13,"centercolor":5, "dots":24}','{"color":84, "bgcolor":2, "sides":4,"centercolor":4, "dots":23}','{"color":29, "bgcolor":6, "sides":10,"centercolor":2, "dots":5}','{"color":35, "bgcolor":7, "sides":3,"centercolor":5, "dots":15}','{"color":20, "bgcolor":7, "sides":4,"centercolor":3, "dots":24}','{"color":99, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":99, "bgcolor":9, "sides":3,"centercolor":5, "dots":14}','{"color":47, "bgcolor":4, "sides":9,"centercolor":5, "dots":23}','{"color":48, "bgcolor":1, "sides":16,"centercolor":3, "dots":12}','{"color":56, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":36, "bgcolor":7, "sides":12,"centercolor":3, "dots":11}','{"color":94, "bgcolor":4, "sides":12,"centercolor":4, "dots":21}','{"color":86, "bgcolor":1, "sides":9,"centercolor":3, "dots":21}','{"color":96, "bgcolor":7, "sides":10,"centercolor":3, "dots":24}','{"color":87, "bgcolor":4, "sides":2,"centercolor":3, "dots":16}','{"color":57, "bgcolor":7, "sides":3,"centercolor":1, "dots":4}','{"color":26, "bgcolor":5, "sides":12,"centercolor":3, "dots":4}','{"color":25, "bgcolor":5, "sides":11,"centercolor":1, "dots":10}','{"color":84, "bgcolor":5, "sides":10,"centercolor":1, "dots":10}','{"color":74, "bgcolor":7, "sides":5,"centercolor":1, "dots":7}','{"color":64, "bgcolor":5, "sides":12,"centercolor":3, "dots":18}','{"color":92, "bgcolor":1, "sides":7,"centercolor":2, "dots":14}','{"color":69, "bgcolor":6, "sides":12,"centercolor":2, "dots":7}','{"color":64, "bgcolor":3, "sides":10,"centercolor":1, "dots":14}','{"color":39, "bgcolor":3, "sides":5,"centercolor":3, "dots":5}','{"color":57, "bgcolor":8, "sides":11,"centercolor":5, "dots":7}','{"color":59, "bgcolor":8, "sides":5,"centercolor":4, "dots":2}','{"color":33, "bgcolor":1, "sides":14,"centercolor":4, "dots":7}','{"color":13, "bgcolor":5, "sides":14,"centercolor":1, "dots":10}','{"color":65, "bgcolor":5, "sides":33,"centercolor":1, "dots":10}','{"color":35, "bgcolor":5, "sides":2,"centercolor":3, "dots":3}','{"color":125, "bgcolor":4, "sides":13,"centercolor":3, "dots":18}','{"color":45, "bgcolor":5, "sides":32,"centercolor":1, "dots":10}','{"color":114, "bgcolor":4, "sides":14,"centercolor":1, "dots":23}','{"color":45, "bgcolor":5, "sides":5,"centercolor":1, "dots":10}','{"color":36, "bgcolor":5, "sides":11,"centercolor":5, "dots":22}','{"color":17, "bgcolor":5, "sides":6,"centercolor":1, "dots":5}','{"color":37, "bgcolor":7, "sides":2,"centercolor":4, "dots":4}','{"color":74, "bgcolor":1, "sides":14,"centercolor":2, "dots":15}','{"color":92, "bgcolor":2, "sides":4,"centercolor":4, "dots":18}','{"color":116, "bgcolor":8, "sides":4,"centercolor":2, "dots":8}','{"color":32, "bgcolor":4, "sides":10,"centercolor":1, "dots":5}','{"color":78, "bgcolor":9, "sides":11,"centercolor":1, "dots":11}','{"color":98, "bgcolor":7, "sides":5,"centercolor":5, "dots":24}','{"color":127, "bgcolor":2, "sides":10,"centercolor":4, "dots":4}','{"color":61, "bgcolor":6, "sides":8,"centercolor":5, "dots":4}','{"color":93, "bgcolor":2, "sides":4,"centercolor":5, "dots":5}','{"color":35, "bgcolor":7, "sides":16,"centercolor":5, "dots":5}','{"color":78, "bgcolor":8, "sides":16,"centercolor":5, "dots":23}','{"color":42, "bgcolor":7, "sides":11,"centercolor":1, "dots":20}','{"color":53, "bgcolor":9, "sides":5,"centercolor":1, "dots":12}','{"color":50, "bgcolor":5, "sides":5,"centercolor":3, "dots":11}','{"color":12, "bgcolor":4, "sides":2,"centercolor":1, "dots":21}','{"color":115, "bgcolor":3, "sides":14,"centercolor":4, "dots":4}','{"color":89, "bgcolor":5, "sides":8,"centercolor":2, "dots":21}','{"color":104, "bgcolor":9, "sides":10,"centercolor":2, "dots":16}','{"color":104, "bgcolor":7, "sides":2,"centercolor":2, "dots":4}','{"color":27, "bgcolor":1, "sides":10,"centercolor":4, "dots":17}','{"color":33, "bgcolor":4, "sides":8,"centercolor":5, "dots":1}','{"color":87, "bgcolor":5, "sides":12,"centercolor":1, "dots":10}','{"color":73, "bgcolor":3, "sides":13,"centercolor":3, "dots":22}','{"color":43, "bgcolor":1, "sides":15,"centercolor":1, "dots":19}','{"color":128, "bgcolor":2, "sides":6,"centercolor":5, "dots":25}','{"color":35, "bgcolor":3, "sides":10,"centercolor":3, "dots":13}','{"color":77, "bgcolor":2, "sides":16,"centercolor":3, "dots":4}','{"color":64, "bgcolor":5, "sides":12,"centercolor":4, "dots":21}','{"color":47, "bgcolor":2, "sides":14,"centercolor":1, "dots":10}','{"color":14, "bgcolor":3, "sides":6,"centercolor":5, "dots":2}','{"color":22, "bgcolor":7, "sides":10,"centercolor":5, "dots":8}','{"color":24, "bgcolor":3, "sides":5,"centercolor":5, "dots":2}']
var tokenID = 0;
if(id == null) 
{
  console.log("ERROR");
}
else
{
  tokenID = parseInt(id);
  if(tokenID >= 444) tokenID = 10;
  console.log(tokenID);
  console.log(seeds[tokenID]);
  console.log(metadata[tokenID]);
  document.getElementById("play").click();
}


document.documentElement.addEventListener('mousedown', () => {
  if (Tone.context.state !== 'running') Tone.context.resume();
});


var APP = {};

// There's a bug that happens occasionally. Intercept it.
// a seed that triggers it: d12d21ddd
window.ABCJS.parse.each = function(a, d, c) {
  var e = (a === undefined) ? 0 : a.length;
  // for (var b = 0, e = a.length; b < e; b++) {
  // ^^ this is the code that gets around it  
  for (var b = 0; b < e; b++) {
    d.apply(c, [a[b], b])
  }
}
document.getElementById("intro").style.display = "none";

var tableCreated = false;
document.getElementById("play").addEventListener("click", function(e) 
{


  var seed = seeds[tokenID];
  if(seed) {

      APP.MusicGenerator.init(seed);
      document.getElementById("play").focus();
       {
        var $el = e.target;
        if($el.getAttribute("data-playing") === "true") {
          APP.MusicGenerator.pause();
          $el.setAttribute("data-playing", "false");
          $el.innerHTML = "&#9658;"; //"Play";
          //APP.MusicGenerator.report();
          console.log("I am here ..............");
         
        } else {
          APP.MusicGenerator.play();
          $el.innerHTML = "Pause";
          $el.setAttribute("data-playing", "true");
          console.log("paaaaaaaaaaaaaaaaaaaaaaaaus");
        }
      }
  } else {
    alert("Please enter a seed into the input");
  }
});


(function() {

  APP.MusicGenerator = {};

  var _v_key      = "WeAddaBabyEetsABoy"; // change this to refresh the seed
  var _roots      = "C Db D Eb E F F# G Ab A Bb".split(" ");
  var _modes      = "maj min".split(" ");
  var _hold       = "HOLD";
  var _container  = document.getElementById("staff-container");
  var _staff      = document.getElementById("staff");
  var _midi       = document.getElementById("midi");
  var _min_oct    = 2;
  var _max_oct    = 5;
  var _playing    = false;
  var _res        = 8;
  var _curr_meas  = 0;
  var _curr_note  = 0;
  var _scale      = [];
  var _measures   = [];
  var _abc        = "";
  var _total_abc  = "";
  var _treb_abc   = "";
  var _bass_abc   = "";
  var _gen_meas   = 0;
  var _meas_gen   = 4;
  var _first_one  = true;

  var _bpm        = null;
  var _generator  = null;
  var _len_seqs   = null;
  var _mode       = null;
  var _output     = null;
  var _root       = null;
  var _seed       = null;
  var _synth      = null;

  APP.MusicGenerator.init = function(seed) {
    _staff.innerHTML = "";
    _seed = seed + _v_key;
    _setGenerator(_seed);
    _setKey();
    if(!_synth) _setSynth();
    _setTransport();
    //_genStaff();

    //_renderStaff();    

    _genLengthSequences();
    _genScale();

    _addMeasure(_meas_gen);
  };

  APP.MusicGenerator.play = playPlayer;
  APP.MusicGenerator.pause = pausePlayer;
  APP.MusicGenerator.report = reportData;

  //////////////
  // PUBLIC METHODS
  //////////////

  // play the player
  function playPlayer() {
    _midi.innerHTML = "";
    Tone.Transport.start();
  }

  // pause the player
  function pausePlayer() {
    Tone.Transport.stop();
  }

  // reporting the data
  function reportData() {
    _output = {
      root: _root, mode: _mode, resolution: _res,
      scale: _scale, measures: _measures, abc: _total_abc
    };
    ABCJS.renderMidi(_midi, _total_abc , {}, {}, {});
    console.log("This is atest");
    console.log(_total_abc);
    console.log(_output);
  }
  
  
  
  

  //////////////
  // PRIVATE METHODS
  //////////////

  // get a unique random number generator based on the seed
  function _setGenerator(seed) {
    _generator = new Math.seedrandom(seed);
  }

  // get randomly generated key and mode
  function _setKey() {
    _root = _roots[Math.floor(_generator.quick() * _roots.length)];

    var mode_index = Math.floor(_generator.quick() * _modes.length);
    _mode = _modes[mode_index];
  }

  // play the bass and treble notes
  function _playSong() {
    var measure = _measures[_curr_meas];
    if(measure) {
      var treb = measure.treb[_curr_note];
      var bass = measure.bass[_curr_note];
      if(treb.chord) {
        _synth.triggerAttackRelease(treb.chord, treb.len + "n");
      }
      if(bass.chord) {
        _synth.triggerAttackRelease(bass.chord, bass.len + "n");
      }
      if(_curr_note + _curr_meas === 0) {
        var hidden = document.querySelector(".hide"); 
        if(hidden) hidden.className = "";
      }
      _curr_note++;
      if(_curr_note >= _res) {
        _curr_note = 0;
        _curr_meas++;
        if(_gen_meas % _meas_gen === 0) {
          _addMeasure(_meas_gen);
        } else if (_gen_meas % _meas_gen === 3) {
          // scroll to the bottom of container
          var hidden = document.querySelector(".hide"); 
          if(hidden) hidden.className = "";          
          _utilScrollTo(_container, _container.scrollHeight, 500);
        }
        _gen_meas++;
      }
    } else {
      pausePlayer();
    }
  }

  // add a measure to the sequence
  function _addMeasure(how_many, loaded) {
    loaded = loaded || 0;
    var get_measure = _getMeasure();
    get_measure.then(function(measure) {
      loaded++;
      // console.log("_getMeasure", measure);
      _measures.push(measure);
      _staffABC(measure);
      if(loaded < how_many) {
        _addMeasure(how_many, loaded);
      } else {
        //_renderStaff();
      }
    });
  }

  // generate a measure's worth of notes
  function _getMeasure() {
    return new Promise(function(resMeasure, rejMeasure) {
      var data = {
        scale: _scale.length / 2,
        bass: { max_notes: 1, offset: 0 },
        treb: { max_notes: 3, offset: Math.floor(_scale.length / 2) }
      };
      var measure = {
        bass: [], treb: []
      };

      // for each clef
      var get_treb = _getClef('treb', data);
      get_treb.then(function(t) {
        // console.log("_getClef: t", t);
        measure.treb = measure.treb.concat(t);
        var get_bass = _getClef('bass', data);
        get_bass.then(function(b) {
          // console.log("_getClef: b", b);
          measure.bass = measure.bass.concat(b);
          resMeasure(measure);
        }, function(b) {
          rejMeasure(b);
        });
      }, function(t) {
        rejMeasure(t);
      });
    });
  }

  // generate notes for a clef
  function _getClef(clef_name, data) {
    return new Promise(function(resClef, rejClef) {
      var _clef_generator = new Math.seedrandom(_generator.int32() + "");
      // find a sequence
      var seq = _len_seqs[Math.floor(_clef_generator.quick() * _len_seqs.length)];
      // shuffle the sequence order
      _utilShuffleArray(seq);

      // set the data
      var max_notes = data[clef_name].max_notes;
      var note_offset = data[clef_name].offset;

      var chord_promises = [];
      // for each length in sequence
      for(var s = 0; s < seq.length; s++) {
        // generate x notes for a random bass count. no rests.
        var note_count = Math.ceil(_clef_generator.quick() * max_notes);
        // generate random note length
        var note_length = seq[s];
        chord_promises.push(_getChord(_clef_generator, data.scale, note_offset, note_count, note_length));
      }

      Promise.all(chord_promises).then(function(chords) {
        var clef = [];
        // console.log("_getChord: promises", chords);
        for(var i = 0; i < chords.length; i++) {
          var chord = chords[i];
          clef.push(chord);
          if(chord.len) {
            var chord_length_i = _res / chord.len;
            for(var e = 0; e < chord_length_i - 1; e++) {
              clef.push(_hold);
            }
          }
        }
        resClef(clef);
      }, function(chords) {
        rejClef(chords);
      });

    });
  }

  // generate the chord notes
  function _getChord(_clef_generator, scale, offset, note_count, note_length) {

    return new Promise(function(resNotes, rejNotes) {
      // used note indexes
      var used_note_indexes = [];
      var note_promises = [];
      // generate the notes
      for(var i = 0; i < note_count; i++) {
        note_promises.push(_getNote(_clef_generator, scale, offset, used_note_indexes));
      }
      Promise.all(note_promises).then(function(chord) {
        // console.log("_getNote: promises", chord);
        var abc = _getABC(chord, note_length);
        // add notes to measure
        resNotes({ abc: abc, chord: chord, len: note_length });
      }, function(chord) {
        rejNotes(chord);
      });
    });
  }

  // generate a note
  function _getNote(_clef_generator, scale, offset, used_note_indexes) {
    return new Promise(function(resNote, rejNote) {
      // add the note to the chord
      resNote(_note());

      function _note() {
        // get a random index
        var index = Math.floor(_clef_generator.quick() * scale) + offset;
        // for measuring note is a "good" one.
        var good_note = true;
        // ensure we havent selected this index
        if(used_note_indexes.indexOf(index) !== -1) good_note = false;
        // or one below it
        if(index > 0 && used_note_indexes.indexOf(index - 1) !== -1) good_note = false;
        // or one above it
        if(used_note_indexes.indexOf(index + 1) !== -1) good_note = false;

        // if we found a good note
        if(good_note) {
          // add the index to the used array
          used_note_indexes.push(index);
          // grab the note
          var note = _scale[index];
          // build the tone version of the note
          var n = note.note + note.octave;
          return n;
        } else {
          return _note();
        }
      }
    });
  }





  //////////////
  // ABC MUSICAL NOTATION
  //////////////

  // get abc notation for notes at a certain length
  function _getABC(notes, len) {
    if(!len) return "";
    var str = notes.length > 1 ? "[" : "";
    for(var n = 0; n < notes.length; n++) {
      str += _ABCNotation(notes[n], len);
    }
    str += notes.length > 1 ? "]" : "";
    return str;
  }

  // render the current abc to staff
  function _renderStaff() {
    var $par = document.createElement("div");
    if(_first_one) {
      _first_one = false;
    } else {
      $par.className = "hide";
    }
    var $el = document.createElement("div");
    // beats per second times four beats * measures per line * 1 second
    $par.appendChild($el);
    _staff.appendChild($par);
    _abc += _treb_abc;
    _abc += "\n" + _bass_abc;
    var cleaned = _abc;
    _total_abc += cleaned;
    _abc = _genStaffHeader();
    _treb_abc = "[V: 1] ";
    _bass_abc = "[V: 2] ";
    _renderABC($el, cleaned);
  }

  function _renderABC(el, abc) {
    console.log(abc);

  }
  
  // take a measure and generate the abc output
  function _staffABC(measure) {
    var abc = "";
    // TODO: every two measures new line with _gen_meas, _treb_abc, _bass_abc
    for(var i = 0; i < measure.treb.length; i++) {
      if(measure.treb[i].abc) {
        _treb_abc += measure.treb[i].abc + " ";
      }
    }
    for(var i = 0; i < measure.bass.length; i++) {
      if(measure.bass[i].abc) {
        _bass_abc += measure.bass[i].abc + " ";
      }
    }
    _treb_abc = _treb_abc.replace(/ $/g, "|");
    _bass_abc = _bass_abc.replace(/ $/g, "|");

  }


  // set the initial staff
  function _genStaff() {
    _abc = [
      "M:/4/4",
      "O:I",
      "R:R",
      "Q:1/4=" + _bpm,
      "",
      "X:2",
      "T:" + _seed.replace(_v_key, ""),
      "C:" + _root.replace(/b$/g, "♭") + " " + _mode + ", " + _bpm + " bpm",
    ].join("\n");
  }
  
  // generate the staff header
  function _genStaffHeader() {
    return [
      "K:" + _root + _mode,
      "L:1/" + _res,
      "%%staves {1 2}",
      "V: 1 clef=treble",
      "V: 2 clef=bass",
      ""
    ].join("\n");
  }

  // abc notation
  function _ABCNotation(note, length) {
    // note = note.replace(/([A-G])b/,"_$1");
    // TODO: know if this is needed based on mode.
    note = note.replace(/([A-G])b/,"$1");
    note = note
      .replace(/(.)1/, "$1,,,")
      .replace(/(.)2/, "$1,,")
      .replace(/(.)3/, "$1,")
      .replace(/(.)4/, "$1");
    if(note.match(/(.)5|6/)) {
      note = note
        .replace(/(.)5/, "$1")
        .replace(/(.)6/, "$1'")
        .toLowerCase();
    }
    note += _res / length;
    return note;
  }





  //////////////
  // DATA
  //////////////

  // generate the scale
  function _genScale() {
    // generate the scale
    var _steps_lib = _genStepsLib();
    var _notes_lib = _genNotesLib();
    var steps = _steps_lib;
    var start = _notes_lib.indexOf(_root + _min_oct);
    var last_note = (_max_oct - _min_oct) * 8;
    for(var o = 0; o < last_note; o++) {
      var index = start + steps[o % steps.length] + (Math.floor(o / steps.length) * 12);
      var note = _notes_lib[index];
      if(note) {
        _scale.push({ note: note.match(/[^\d]+/)[0], octave: note.match(/\d/)[0] });
      }
    }
    if(!_scale.length) console.error("Too high up. Lower the octave or note count.");
  }

  // potential combinations of note lengths
  // this could be done programmatically.
  function _genLengthSequences() {
    _len_seqs = [
      [1],
      [2,2],
      [2,4,4],
      [2,4,8,8],
      [4,4,4,4],
      [2,8,8,8,8],
      [4,4,4,8,8],
      [8,8,8,8,8,8,8,8],
      // [2,4,8,16,16],
      // [2,4,16,16,16,16],
      // [2,8,8,8,16,16],
      // [2,8,8,16,16,16,16],
      // [2,8,16,16,16,16,16,16],
      // [2,16,16,16,16,16,16,16,16],
      // [4,4,4,8,16,16],
      // [4,4,4,16,16,16,16],
      // [4,4,8,8,16,16,16,16],
      // [4,4,8,16,16,16,16,16,16],
      // [4,4,16,16,16,16,16,16,16,16],
      // [4,8,8,16,16,16,16,16,16,16,16],
      // [4,8,16,16,16,16,16,16,16,16,16,16],
      // [4,16,16,16,16,16,16,16,16,16,16,16,16],
      // [8,8,8,8,8,8,8,16,16],
      // [8,8,8,8,8,8,16,16,16,16],
      // [8,8,8,8,8,16,16,16,16,16,16],
      // [8,8,8,8,16,16,16,16,16,16,16,16],
      // [8,8,8,16,16,16,16,16,16,16,16,16,16],
      // [8,8,16,16,16,16,16,16,16,16,16,16,16,16],
      // [8,16,16,16,16,16,16,16,16,16,16,16,16,16,16],
      // [16,16,16,16,16,16,16,16,16,16,16,16,16,16,16,16],
    ];
  }

  // set the notes for the key
  function _genStepsLib() {
    // generate major and minor integer step arrays from whole/half notation
    // whole/half note steps for minor and major
    var mode = {
      // ionian:     "W W H W W W H",
      // dorian:     "W H W W W H W",
      // phrygian:   "H W W W H W W",
      // lydian:     "W W W H W W H",
      // mixolydian: "W W H W W H W",
      // aeolian:    "W H W W H W W",
      // locrian:    "H W W H W W W",
      maj:        "W W H W W W H",
      min:        "W H W W H W W",
    }[_mode].split(" ");
    // start each with root step
    var steps = [0];

    // loop through
    var step = 0;
    for(var s = 0; s < mode.length; s++) {
      var key = mode[s];
      if(key === "W") {
        steps.push(steps[s] + 2);
      } else if(key == "WH") {
        steps.push(steps[s] + 3);
      } else {
        steps.push(steps[s] + 1);
      }
      step++;
    }
    return steps;
  }

  // generate every possible note/octave pairing in order
  function _genNotesLib() {
    var notes = [];
    for(var i = 0; i < 9; i++) {
      var n = "C Db D Eb E F Gb G Ab A Bb B".split(" ");
      for(var x = 0; x < n.length; x++) notes.push(n[x] + i);
    }
    return notes;
  }
  




  //////////////
  // TONE.js
  //////////////

  // set the tone js transport
  function _setTransport() {
    _bpm = Math.round(_generator.quick() * 60) + 60;
    _bpm = 150;
    Tone.Transport.bpm.value = _bpm;
    Tone.Transport.scheduleRepeat(function(time) {
      _playSong();
    }, _res + "n");
  }

  // set the synthesizer
  function _setSynth() {

    // master compression
    var multiband = new Tone.MultibandCompressor({
      lowFrequency: 200,
      highFrequency: 1300,
      low: { threshold: -12 }
     });

    var reverb = new Tone.Freeverb();
        reverb.roomSize.value = 0.6;
        reverb.wet.value = 0.2;

    Tone.Master.chain(reverb, multiband);

    // SimpleSynth SimpleAM SimpleAM

    // _synth = new Tone.PolySynth(6, Tone.SimpleAM).toMaster();
    _synth = new Tone.PolySynth(3, Tone.SimpleAM).toMaster();
    _synth.set({
      oscillator: {
        type: 'fmsquare',
        modulationType: 'sawtooth',
        modulationIndex: 3,
        harmonicity: 3.4
      },
      envelope: {
        attack: 0.05,
        decay: 0.1,
        sustain: 0.3,
        release: 1
      }
    });
  }

  



  
  //////////////
  // UTILS
  //////////////

  // shuffle an array
  // http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
  function _utilShuffleArray(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(_generator() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  function _utilScrollTo(element, to, duration) {
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function() {
      element.scrollTop = element.scrollTop + perTick;
      if (element.scrollTop === to) return;
      _utilScrollTo(element, to, duration - 10);
    }, 10);
  }


}());

//===========================================================

const WIDTH = 300
const HEIGHT = 300

function getP5Element(index) {
	let element = document.getElementById("drawing" + index).getElementsByClassName("drawing-p5holder")[0]
	return element
}

// Run this function after the page is loaded
//document.addEventListener("DOMContentLoaded", function(){
document.getElementById("play").addEventListener("click", function (e) {

  if(animationCreated)
  {
    return; // We need to change only the music
  }

  console.log(animationCreated);
  

	let mainElement = document.getElementById("main")
    let NFTCounter = 0;
		
	// Ignore this section if you want
	// This is me adding a label and a canvas-holder to each swatch
	// For each drawing
    let color = Math.floor((Math.random() * 120) + 10);
    console.log(color);

    let bgcolor = Math.floor((Math.random() * 9) + 1);
    let sides = Math.floor((Math.random() * 15) + 2);
    let dots = Math.floor((Math.random() * 25) + 1);
    let centercolor = Math.floor((Math.random() * 5) + 1);

    var args = '{"color":'+color+', "bgcolor":'+bgcolor+', "sides":'+sides+',"centercolor":'+centercolor+', "dots":'+dots+'}';
    console.log(args);
    args = metadata[tokenID];
    
    var userSeed = seeds[tokenID];

 

	for (var i = 0; i <= 1; i++)
    {
		let el = document.createElement("div")
		el.className = "drawing"
		el.id = "drawing" + i
		mainElement.append(el)


		// Add a label
		let label = document.createElement("div")
		label.className = "drawing-label"
    if(i ==0)
    {
      label.innerHTML = "Music Generated";

    }
    else
    {
      label.innerHTML = "SEED : " + userSeed + "<br> TOKEN ID : " + tokenID;
    }
		el.append(label)
    NFTCounter++;

		// Add a div to hold the canvas (so we can resize it independently of the outer frame)
		let canvasHolder = document.createElement("div")
		canvasHolder.className = "drawing-p5holder"
		canvasHolder.style = `width:${WIDTH};height:${HEIGHT}`
		el.append(canvasHolder)
	}

	// Comment out these lines to not draw each
    setupDrawing3(args);
    console.log(args);
    animationCreated = true;

});





/******************************************************/

function addRow() {
          
  var myName = document.getElementById("name");
  var age = document.getElementById("age");
  var table = document.getElementById("myTableData");

  var rowCount = table.rows.length;
  var row = table.insertRow(rowCount);

  row.insertCell(0).innerHTML= '<input type="button" value = "Delete" onClick="Javacsript:deleteRow(this)">';
  row.insertCell(1).innerHTML= myName.value;
  row.insertCell(2).innerHTML= age.value;

}

function deleteRow(obj) {
    
  var index = obj.parentNode.parentNode.rowIndex;
  var table = document.getElementById("myTableData");
  table.deleteRow(index);
  
}
var isArtGenerated = [];
for (i = 0; i < 100; i++)
{  
  isArtGenerated[i] = false;
} 

const seedWords = ["Tanish","Orange","Twitter","Facebook","Saab", "Volvo", "BMW","ICP","Bitcoin","Ethereum","Idnai","Waheed","Rahuman","Tanish","Shazana"];

function addTable() {
    
  var myTableDiv = document.getElementById("myDynamicTable");
    
  var table = document.createElement('TABLE');
  table.border='1';
  
  var tableBody = document.createElement('TBODY');
  table.appendChild(tableBody);

  var buttons = 0;

  var playButtons = [];
  //Generate Play Buttons
  for (var i=0; i<3; i++){
     var tr = document.createElement('TR');
     tableBody.appendChild(tr);
     
     for (var j=0; j<4; j++){
         var td = document.createElement('TD');
         td.width='75';

         let btn = document.createElement("button");
         btn.innerHTML = "&#9658;"; //"Play"+buttons;
         btn.id = seedWords[buttons]; //"play"+buttons;
         btn.className = buttons;
         console.log(btn.id);


         let mainDiv = document.createElement("div");
         mainDiv.id = "main"+seedWords[buttons]; 

         console.log("main"+seedWords[buttons]);
         
         btn.onclick = function () {

         console.log("I am clicked" + "play"+this.id);

         generateArt(this.id,this.className);
         generateMusic(this.id,this.id);          
          
        };         
         buttons++;

                   
         td.appendChild(btn);
         td.appendChild(mainDiv);

         tr.appendChild(td);
     }
  }
  myTableDiv.appendChild(table);
}


//Everytime Play Button is clicked called
function stopPlaying(seed) {
  var innerHTML = document.getElementById(seed);
  console.log(seed);
}

function generateMusic(seed,button)
{
  seedWords.forEach(stopPlaying);

  if(seed) {

    console.log(button);
    APP.MusicGenerator.init(seed);
    console.log("Init is called");

    var $el = document.getElementById(seed); 
    document.getElementById(seed).focus();
    var innerHTML = document.getElementById(seed).innerHTML;

     {
      if($el.getAttribute("data-playing") === "true") {
        APP.MusicGenerator.pause();
        $el.setAttribute("data-playing", "false");
        $el.innerHTML = "&#9658;";
        //APP.MusicGenerator.report();
        console.log("I am Playing my seed is "+ seed);
       
      } else {
        APP.MusicGenerator.play();
        $el.innerHTML = "&#9632;";
        $el.setAttribute("data-playing", "true");
        console.log("I am pause my seed is " + seed);
      }
    }
} else {
  alert("Please enter a seed into the input");
}  
}

function generateArt(art,arrayIndex) 
{
  console.log("Array................"  + art);

  if(isArtGenerated[arrayIndex])
  {
    return 0;
  }
  
  let mainElement = document.getElementById("main"+art);
  let NFTCounter = 0;
		
	// Ignore this section if you want
	// This is me adding a label and a canvas-holder to each swatch
	// For each drawing
    let color = Math.floor((Math.random() * 120) + 10);
    console.log(color);

    let bgcolor = Math.floor((Math.random() * 9) + 1);
    let sides = Math.floor((Math.random() * 15) + 2);
    let dots = Math.floor((Math.random() * 25) + 1);
    let centercolor = Math.floor((Math.random() * 5) + 1);

    var args = '{"color":'+color+', "bgcolor":'+bgcolor+', "sides":'+sides+',"centercolor":'+centercolor+', "dots":'+dots+'}';
    console.log(args);

    args = metadata[tokenID];
    console.log(args);

    var userSeed = art;   

    if(userSeed.length > 10)
    {
      args = userSeed;
    }

    console.log("33333333333333");

	for (var i = 0; i <= 1; i++)
    {
		let el = document.createElement("div")
		el.className = "drawing"+arrayIndex
		el.id = "drawing" + i
		mainElement.append(el)


		// Add a label
		let label = document.createElement("div")
		label.className = "drawing-label"
		label.innerHTML = "Music Generated with Image" + arrayIndex; // + i + ":" + args //drawingTitles[i]
		el.append(label)
        NFTCounter++;

		// Add a div to hold the canvas (so we can resize it independently of the outer frame)
		let canvasHolder = document.createElement("div")
		canvasHolder.className = "drawing-p5holder"+arrayIndex
		canvasHolder.style = `width:${WIDTH};height:${HEIGHT}`
		el.append(canvasHolder)
    console.log("I am in the 1153");
	}

	// Comment out these lines to not draw each
    setupDrawing100(args,arrayIndex);
    console.log("ssssssssssssds" + args);
    animationCreated = true;

    isArtGenerated[arrayIndex] = true;
}
/************************************************************/

function setupDrawing3(arg_sides) {

	function setup(p) {
		p.createCanvas(WIDTH, HEIGHT);
        p.id = "drawing";
		p.colorMode(p.HSL);
        p.background(0);  //Parameter
 	}

	function draw(p) {

        const centercolor = ["red", "orange","white","green", "yellow", "blue","#00FFFF"];


        const colors = [
            "AliceBlue",
            "AntiqueWhite",
            "Aqua",
            "Aquamarine",
            "Azure",
            "Beige",
            "Bisque",
            "Black",
            "BlanchedAlmond",
            "Blue",
            "BlueViolet",
            "Brown",
            "BurlyWood",
            "CadetBlue",
            "Chartreuse",
            "Chocolate",
            "Coral",
            "CornflowerBlue",
            "Cornsilk",
            "Crimson",
            "Cyan",
            "DarkBlue",
            "DarkCyan",
            "DarkGoldenRod",
            "DarkGray",
            "DarkGrey",
            "DarkGreen",
            "DarkKhaki",
            "DarkMagenta",
            "DarkOliveGreen",
            "DarkOrange",
            "DarkOrchid",
            "DarkRed",
            "DarkSalmon",
            "DarkSeaGreen",
            "DarkSlateBlue",
            "DarkSlateGray",
            "DarkSlateGrey",
            "DarkTurquoise",
            "DarkViolet",
            "DeepPink",
            "DeepSkyBlue",
            "DimGray",
            "DimGrey",
            "DodgerBlue",
            "FireBrick",
            "FloralWhite",
            "ForestGreen",
            "Fuchsia",
            "Gainsboro",
            "GhostWhite",
            "Gold",
            "GoldenRod",
            "Gray",
            "Grey",
            "Green",
            "GreenYellow",
            "HoneyDew",
            "HotPink",
            "IndianRed",
            "Indigo",
            "Ivory",
            "Khaki",
            "Lavender",
            "LavenderBlush",
            "LawnGreen",
            "LemonChiffon",
            "LightBlue",
            "LightCoral",
            "LightCyan",
            "LightGoldenRodYellow",
            "LightGray",
            "LightGrey",
            "LightGreen",
            "LightPink",
            "LightSalmon",
            "LightSeaGreen",
            "LightSkyBlue",
            "LightSlateGray",
            "LightSlateGrey",
            "LightSteelBlue",
            "LightYellow",
            "Lime",
            "LimeGreen",
            "Linen",
            "Magenta",
            "Maroon",
            "MediumAquaMarine",
            "MediumBlue",
            "MediumOrchid",
            "MediumPurple",
            "MediumSeaGreen",
            "MediumSlateBlue",
            "MediumSpringGreen",
            "MediumTurquoise",
            "MediumVioletRed",
            "MidnightBlue",
            "MintCream",
            "MistyRose",
            "Moccasin",
            "NavajoWhite",
            "Navy",
            "OldLace",
            "Olive",
            "OliveDrab",
            "Orange",
            "OrangeRed",
            "Orchid",
            "PaleGoldenRod",
            "PaleGreen",
            "PaleTurquoise",
            "PaleVioletRed",
            "PapayaWhip",
            "PeachPuff",
            "Peru",
            "Pink",
            "Plum",
            "PowderBlue",
            "Purple",
            "RebeccaPurple",
            "Red",
            "RosyBrown",
            "RoyalBlue",
            "SaddleBrown",
            "Salmon",
            "SandyBrown",
            "SeaGreen",
            "SeaShell",
            "Sienna",
            "Silver",
            "SkyBlue",
            "SlateBlue",
            "SlateGray",
            "SlateGrey",
            "Snow",
            "SpringGreen",
            "SteelBlue",
            "Tan",
            "Teal",
            "Thistle",
            "Tomato",
            "Turquoise",
            "Violet",
            "Wheat",
            "White",
            "WhiteSmoke",
            "Yellow",
            "YellowGreen",
          ];  
          
          
        const bgcolors = ["#13274F","#B5A642","#002244","#002E63","#3D2B1F","#000000","#612302","#00308F","#32174d","#343434","#002fa7"];



        const obj = JSON.parse(arg_sides);


		// Or try it with trails
		p.background(bgcolors[obj.bgcolor]);  //Parameter
            
		let t = p.frameCount *.01


		
		// Sometimes its easiest to translate into the center of the screen
		// so that the origin (0,0) is at the center and not the top left
		p.push()
		p.translate(p.width/2, p.height/2)

		p.noStroke()
		p.fill(centercolor[obj.centercolor]) // Center Point

		// See? The (0,0) point is now in the center of the screen
		p.circle(0, 0, 10, 10)


		let sides = obj.sides;

		// To make mandalas or other forms of repetition, 
		// run your drawing function *multiple times*

		// Here, I'm running it "sides" times, 
		// and each time, rotating a little more
		// to create a flower shape
		for (var i = 0; i < sides; i++) {
			
			p.rotate(Math.PI*2/sides)   

			
			// Create a number of dots that are positioned with noise
			let dotCount = obj.dots; // Parameter  2


              

			var col = obj.color; // Parameter
            var start = col;
            var end = start+10;

			for (var j = 0; j < dotCount; j++) {
				let offsetX = 200*p.noise(t + 50, j*.1) - 80
				let offsetY = 300*p.noise(t + 30, j*.1) - 80
				
				let hue = 115*j/sides
				p.fill(hue, 3, 30 + 60*j/dotCount, .25)
				p.circle(offsetX, offsetY - 2, 2)
				p.fill(colors[col])
				p.circle(offsetX, offsetY, 5)
				
				col++;
                
				if(col > end)
				{
					col = start;
				}
			}
		
		}
		p.pop()
		
	}


	let element = getP5Element(0) // <- Make sure to change this to the right index

	let myP5 = new p5(function(p) {
		p.setup = () => setup(p)
		p.draw = () => draw(p)
	}, element);
}


function setupDrawing100(arg_sides,arrayIndex) {

	function setup(p) {
		p.createCanvas(WIDTH, HEIGHT);
        p.id = "drawing"+arrayIndex;
		p.colorMode(p.HSL);
        p.background(0);  //Parameter
 	}

	function draw(p) {

        const centercolor = ["red", "orange","white","green", "yellow", "blue","#00FFFF"];


        const colors = [
            "AliceBlue",
            "AntiqueWhite",
            "Aqua",
            "Aquamarine",
            "Azure",
            "Beige",
            "Bisque",
            "Black",
            "BlanchedAlmond",
            "Blue",
            "BlueViolet",
            "Brown",
            "BurlyWood",
            "CadetBlue",
            "Chartreuse",
            "Chocolate",
            "Coral",
            "CornflowerBlue",
            "Cornsilk",
            "Crimson",
            "Cyan",
            "DarkBlue",
            "DarkCyan",
            "DarkGoldenRod",
            "DarkGray",
            "DarkGrey",
            "DarkGreen",
            "DarkKhaki",
            "DarkMagenta",
            "DarkOliveGreen",
            "DarkOrange",
            "DarkOrchid",
            "DarkRed",
            "DarkSalmon",
            "DarkSeaGreen",
            "DarkSlateBlue",
            "DarkSlateGray",
            "DarkSlateGrey",
            "DarkTurquoise",
            "DarkViolet",
            "DeepPink",
            "DeepSkyBlue",
            "DimGray",
            "DimGrey",
            "DodgerBlue",
            "FireBrick",
            "FloralWhite",
            "ForestGreen",
            "Fuchsia",
            "Gainsboro",
            "GhostWhite",
            "Gold",
            "GoldenRod",
            "Gray",
            "Grey",
            "Green",
            "GreenYellow",
            "HoneyDew",
            "HotPink",
            "IndianRed",
            "Indigo",
            "Ivory",
            "Khaki",
            "Lavender",
            "LavenderBlush",
            "LawnGreen",
            "LemonChiffon",
            "LightBlue",
            "LightCoral",
            "LightCyan",
            "LightGoldenRodYellow",
            "LightGray",
            "LightGrey",
            "LightGreen",
            "LightPink",
            "LightSalmon",
            "LightSeaGreen",
            "LightSkyBlue",
            "LightSlateGray",
            "LightSlateGrey",
            "LightSteelBlue",
            "LightYellow",
            "Lime",
            "LimeGreen",
            "Linen",
            "Magenta",
            "Maroon",
            "MediumAquaMarine",
            "MediumBlue",
            "MediumOrchid",
            "MediumPurple",
            "MediumSeaGreen",
            "MediumSlateBlue",
            "MediumSpringGreen",
            "MediumTurquoise",
            "MediumVioletRed",
            "MidnightBlue",
            "MintCream",
            "MistyRose",
            "Moccasin",
            "NavajoWhite",
            "Navy",
            "OldLace",
            "Olive",
            "OliveDrab",
            "Orange",
            "OrangeRed",
            "Orchid",
            "PaleGoldenRod",
            "PaleGreen",
            "PaleTurquoise",
            "PaleVioletRed",
            "PapayaWhip",
            "PeachPuff",
            "Peru",
            "Pink",
            "Plum",
            "PowderBlue",
            "Purple",
            "RebeccaPurple",
            "Red",
            "RosyBrown",
            "RoyalBlue",
            "SaddleBrown",
            "Salmon",
            "SandyBrown",
            "SeaGreen",
            "SeaShell",
            "Sienna",
            "Silver",
            "SkyBlue",
            "SlateBlue",
            "SlateGray",
            "SlateGrey",
            "Snow",
            "SpringGreen",
            "SteelBlue",
            "Tan",
            "Teal",
            "Thistle",
            "Tomato",
            "Turquoise",
            "Violet",
            "Wheat",
            "White",
            "WhiteSmoke",
            "Yellow",
            "YellowGreen",
          ];  
          
          
        const bgcolors = ["#13274F","#B5A642","#002244","#002E63","#3D2B1F","#000000","#612302","#00308F","#32174d","#343434","#002fa7"];



        const obj = JSON.parse(arg_sides);


		// Or try it with trails
		p.background(bgcolors[obj.bgcolor]);  //Parameter
            
		let t = p.frameCount *.01


		
		// Sometimes its easiest to translate into the center of the screen
		// so that the origin (0,0) is at the center and not the top left
		p.push()
		p.translate(p.width/2, p.height/2)

		p.noStroke()
		p.fill(centercolor[obj.centercolor]) // Center Point

		// See? The (0,0) point is now in the center of the screen
		p.circle(0, 0, 10, 10)


		let sides = obj.sides;

		// To make mandalas or other forms of repetition, 
		// run your drawing function *multiple times*

		// Here, I'm running it "sides" times, 
		// and each time, rotating a little more
		// to create a flower shape
		for (var i = 0; i < sides; i++) {
			
			p.rotate(Math.PI*2/sides)   

			
			// Create a number of dots that are positioned with noise
			let dotCount = obj.dots; // Parameter  2


              

			var col = obj.color; // Parameter
            var start = col;
            var end = start+10;

			for (var j = 0; j < dotCount; j++) {
				let offsetX = 200*p.noise(t + 50, j*.1) - 80
				let offsetY = 300*p.noise(t + 30, j*.1) - 80
				
				let hue = 115*j/sides
				p.fill(hue, 3, 30 + 60*j/dotCount, .25)
				p.circle(offsetX, offsetY - 2, 2)
				p.fill(colors[col])
				p.circle(offsetX, offsetY, 5)
				
				col++;
                
				if(col > end)
				{
					col = start;
				}
			}
		
		}
		p.pop()
		
	}


	let element = getP5Element(0) // <- Make sure to change this to the right index

	let myP5 = new p5(function(p) {
		p.setup = () => setup(p)
		p.draw = () => draw(p)
	}, element);
}
